import { lazy } from "react";
import { mapRemoteKeys } from "../config/mfRemotes";
import { loadRemoteComponent } from "../microfrontends/loadRemoteModule";
import { type RemoteId } from "../microfrontends/remoteRegistry";

export const LazyTermSheet = lazy(() =>
  import("@toorak/op-web-common-service").then((module) => ({
    default: module.TermSheetV2
  }))
);

export function loadLazyRemote(remoteId: RemoteId) {
  return loadRemoteComponent(remoteId).then((Remote) => ({
    default: Remote
  }));
}

export const LazyRemotes = mapRemoteKeys((id) =>
  lazy(() => loadLazyRemote(id))
);

export const LazyBudgetReview = LazyRemotes.budgetReview;
export const LazyBudgetReconcile = LazyRemotes.budgetReconcile;
